import React, {useContext} from "react";
import {LanguageContext} from "../../App";
import classes from "../../styles/component_styles/services.module.scss";
import image from '../../images/services/ResidentialRenovation.webp';
import {FaHome} from "react-icons/fa";
import {Col, Container, Row} from "react-bootstrap";
import {Helmet} from "react-helmet";

function ResidentialRemodelingPage() {

    const languageContext = useContext(LanguageContext);

    return(
        <>

            <Helmet>
                <title>Residential Remodeling Services in Charlotte NC</title>
                <meta
                    name="description"
                    content="Explore residential remodeling services in Charlotte NC. From kitchens to bathrooms, our expert team delivers quality solutions for your home renovation needs."
                />
            </Helmet>

            <div className={classes.start_image}>
                <h1 className={classes.start_message}><FaHome className={classes.servicesIcon}/> {languageContext.services.ResidentialRemodelingPage.title}</h1>
                <p className={classes.darkText}>{languageContext.services.ResidentialRemodelingPage.description}</p>
            </div>

            <Container>
                <Row>
                    <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                        <p className={classes.description}>
                            {languageContext.services.ResidentialRemodelingPage.text1}
                            <br/><br/>
                            <span>{languageContext.services.ResidentialRemodelingPage.text2}</span>
                            <br/>
                            {languageContext.services.ResidentialRemodelingPage.text3}
                            <br/><br/>
                            <span>{languageContext.services.ResidentialRemodelingPage.text4}</span>
                            <br/>
                            {languageContext.services.ResidentialRemodelingPage.text5}
                            <br/><br/>
                            <span>{languageContext.services.ResidentialRemodelingPage.text6}</span>
                            <br/>
                            {languageContext.services.ResidentialRemodelingPage.text7}
                            <br/><br/>
                            <span>{languageContext.services.ResidentialRemodelingPage.text8}</span>
                            <br/>
                            {languageContext.services.ResidentialRemodelingPage.text9}
                        </p>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                        <img src={image} className={classes.image}/>
                    </Col>
                </Row>
            </Container>
        </>
    );

}

export default ResidentialRemodelingPage;